<template>
    <modal
        name="sesion-aviso"
        transition="pop-out"
        :width="800"
        height="auto"
        scrollable
        id="sesion-aviso"
        :adaptive="true"
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div class="col-10">
                        <h2 class="text-dark">{{$t('partido.tiempo_avios_titulo')}} <i class="fas fa-stopwatch" style="color: #ff0000;"></i></h2>
                    </div>
                    <div class="col-2">
                        <button type="button" class="close" @click.prevent="close()">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <h3 class="text-danger">{{$t('partido.tiempo_avios_hora')}} {{tiempo == true ? '00:00': tiempo}}</h3>
                <h4 class="text-danger">{{$t('partido.tiempo_aviso_mensaje')}}</h4>
            </div>
            <div class="card-footer text-right">
                <slot name="footer">
                    <Button type="button" name="button" @click.prevent="close()">{{$t('partido.tiempo_modal_cerrar')}}</Button>
                </slot>
            </div>
        </div>
    </modal>
</template>

<script>

export default {
    props: ['tiempo'],
    methods: {
        close() {
            this.$emit('close');
        }
    },
}

</script>